import axios from 'axios'
import FacturaCompraAPI from '@/api/compra/factura'

export default {
    namespaced: true,
    state: {
        facturas: []


    },
    mutations: {

    },
    getters: {


    },
    actions: {
        fetch_factura_compra(_, params) {
            return FacturaCompraAPI.index(params);
        },

        fetch_resumen_factura_compra(_, params) {
            return FacturaCompraAPI.resumen(params);
        },

    }
}

